<template>
  <div class="top-filter-wrapper">
    <div class="line-one classify-line" id="classifyLine">
      <span class="line-label">分类</span>
      <div
        class
        v-if="categoryList && categoryList.length"
        :class="{
            'filter-list': true,
          }"
        >
        <span
          :class="{
              'filter-item': true,
              'filter-item-all': true,
              'filter-item-select': categoryId1 == 0
            }"
          @click="_classifyChange({ categoryId: 0, categoryName: '全部' })"
        >全部</span>
        <div class="in-list" id="classifyInList">
          <span
            :class="{
                'filter-item': true,
                'filter-item-select': item.categoryId == categoryId1
              }"
              v-for="(item, index) in categoryList1"
              :key="index"
              @click="_classifyChange(Object.assign(item, {index}))"
            >{{item.categoryName}}</span>
        </div>
        <span v-if="openLineShow" class="icon-more" @click.stop="_openLine"><span>更多</span><i class="iconfont iconxiangzuo" :class="openLine ? 'icon-rotate' : ''" :title="openLine ? '收起' : '展开'"></i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { productType } from "config/config";
import { localStorageUtil } from "utils/util";
import { reqGetClassify, reqGetTopicList } from "api/topic-classes";
export default {
  name: "topFilter",
  props: {
    subjectId: {
      type: [Number, String, null]
    },
    categoryId: {
      type: [Number, String, null]
    },
    categoryList: {
      type: Array,
    }
  },
  data() {
    return {
      productType: 1,
      isSelect: 0,
      noScroll: true, // 班级小组列表是否要滚动
      preDis: true,
      nextDis: false,
      lastClickTime: null,
      openLine: false,
      openLineShow: false,
      subjects_t: null,
      categoryId1: null,
    };
  },
  computed: {
    ...mapState(["isLogin", "accountInfo"]),
    categoryList1() {
      if(this.categoryList.length) {
        return [...this.categoryList].splice(1, this.categoryList.length - 1);
      }else {
        return [];
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val, oldVal) {}
    },
    categoryList: {
      immediate: true,
      handler(val, oldVal) {
        if(val && val.length) {
          this.categoryId1 = this.categoryId;
          this.$nextTick(() => {
            let _allH = $('#classifyInList').height();
            if(_allH < 40) {
              this.openLineShow = false;
            }else {
              this.openLineShow = true;
            }
          });
        }
      }

    },
    categoryId: {
      immediate: true,
      handler(val, oldVal) {
        if(val) {
          this.categoryId1 = val;

        }
      }
    }
  },
  methods: {
    
    /**
     * 专题select
     * **/
    _classifyChange(item) {
      if(!this.isLogin) {
        this.$emit('handleLimit');
        console.log('not login', this.isLogin);
        return;
      }
      let _accountInfo = localStorageUtil.getItem('accountInfo');
      let _lastSelect_t = localStorageUtil.getItem(`${_accountInfo.phone}_lastSelect_t`);
      this.categoryId1 = item.categoryId;
      let categories = _lastSelect_t['categories'];
      if(!categories) {
        categories = {};
      }
      _lastSelect_t.categoryId = this.categoryId1;
      categories[this.subjectId] = this.categoryId1;
      _lastSelect_t.categories = categories;
      localStorageUtil.setItem(`${_accountInfo.phone}_lastSelect_t`, _lastSelect_t);
      this.$emit('handleChange', {
        categoryId: this.categoryId1,
      });
    },
    /**
     * 省份展开折叠
     * **/
    _openLine(type) {
      let _allH = $('#classifyInList').height();
      if(this.openLine || type === 'close') {
        this.openLine = false;
        $('#classifyLine').animate({
          height: 34
        });
        return;
      }else {
        $('#classifyLine').animate({
          height: _allH
        });
        
      }
      this.openLine = !this.openLine;
    },
  },
  async created() {
    if (isNaN(productType)) {
      this.productType = 1;
    } else {
      this.productType = Number(productType);
    }
    
  }
};
</script>
<style lang="less">
@color-main: #03B2B2;
.top-filter-wrapper {
  width: 100%;
  // min-height: 200px;
  background: #fff;
  padding: 20px 0px 14px 20px;
  .line-one {
    display: inline-block;
    height: 34px;
    line-height: 34px;
    width: 100%;
    overflow: hidden;
    position: relative;
    & + .line-one {
      margin-top: 2px;
    }

    &:after {
      content: "";
      display: inline-block;
      width: 3px;
      height: 15px;
      background: @color-main;
      border-radius: 16px;
      position: absolute;
      top: 9px;
      left: 0;
    }

    .line-label {
      width: 50px;
      text-align: justify;
      font-size: 20px;
      font-weight: bold;
      display: inline-block;
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      color: #999999;
      padding-left: 10px;
      &:after {
        content: "";
        display: inline-block;
        width: 100%;
      }
    }
    .filter-list {
      display: inline-block;
      width: calc(100% - 70px);
      vertical-align: top;
      line-height: 28px;
      padding-left: 26px;
      margin-top: 2px;
      .filter-item {
        display: inline-block;
        font-size: 14px;
        padding: 0px 16px;
        border-radius: 4px;
        color: #444444;
        cursor: pointer;
        &:not(:last-of-type) {
          margin-right: 4px;
        }
        &.filter-item-select {
          color: #fff;
          background: @color-main;
          // font-weight: bold;
        }
        &:not(.filter-item-select):hover {
          color: @color-main;
        }
      }
    }

  }
  .classify-line {
    min-width: 34px;
    .filter-list {
      display: inline-block;
      width: calc(100% - 60px);
      height: 100%;
      // padding-left: 10px;
      vertical-align: top;
      position: relative;
      .filter-item-all {
        display: inline-block;
        vertical-align: top;
        margin-right: 4px;
      }
      .in-list {
        display: inline-block;
        width: calc(100% - 30px - 60px);
        // height: 100%;
        .filter-item {
          margin-bottom: 10px;
        }
        
      }
      .icon-more {
        position: absolute;
        top: 0;
        right: 4px;
        color: #B3B3B3;
        cursor: pointer;
        height: 16px;
        line-height: 16px;
        margin-top: 6px;
        &:hover {
          color: @color-main;
        }
        span {
          display: inline-block;
          line-height: 16px;
          margin-right: 4px;
        }
        .iconxiangzuo {
          display: inline-block;
          line-height: 14px;
          height: 14px;
          vertical-align: top;
          margin-left: 2px;
          transform: rotate(-90deg);
          transition: transform .3s;
          font-size: 12px;
          &.icon-rotate {
            transform: rotate(-270deg);
          }
        }
      }
    }
  }
}
</style>